import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=6b88d868&scoped=true&"
import script from "./payments.vue?vue&type=script&lang=js&"
export * from "./payments.vue?vue&type=script&lang=js&"
import style0 from "./payments.vue?vue&type=style&index=0&id=6b88d868&prod&lang=css&"
import style1 from "./payments.vue?vue&type=style&index=1&id=6b88d868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88d868",
  null
  
)

export default component.exports